import script from "./NotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=5fa604b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa604b2"]])

export default __exports__